import type { CalendarDate } from '@internationalized/date'
import { parseDate } from '@internationalized/date'

// Accepts a bare day or a full ISO timestamp; only the calendar day is kept.
const ISO_DAY = /^(\d{4}-\d{2}-\d{2})(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?)?$/

export function fromIsoDate(value: string | null | undefined): CalendarDate | undefined {
  const day = value?.match(ISO_DAY)?.[1]
  if (!day) {
    return undefined
  }
  try {
    return parseDate(day)
  } catch {
    return undefined
  }
}
